<form
  class="flex flex-col gap-4 mt-10"
  [formGroup]="form"
  (ngSubmit)="onSubmit()">
  <div class="w-full h-[calc(100vh-185px)] flex flex-col gap-4">
    <div class="flex flex-col gap-4 justify-between">
      <div class="w-full flex flex-col gap-5">
        <qaroni-account-avatar
          [name]="account?.name ?? ''"
          [image]="account?.image ?? null"
          [id]="account?.id ?? null" />

        <div class="w-full text-center flex flex-col justify-center gap-1 mt-4">
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="name" type="text" required />
            @if (checkInputErrors(name)) {
              <qaroni-input-error-message matError [errors]="name.errors" />
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full mx-auto text-center flex gap-3 justify-center">
    <button
      (click)="changeViewInfo()"
      class="min-w-[80px] md:min-w-[110px] text-qaroni-text-primary text-base leading-6 font-semibold">
      Cancelar
    </button>

    <button
      mat-flat-button
      class="!min-w-[80px] md:!min-w-[110px] !px-5 !py-3 !text-base !font-normal !tracking-normal !rounded-full !h-[45px]"
      color="primary"
      [isLoading]="submitting"
      qaroniLoadButton
      type="submit"
      [disabled]="!validatedForm">
      Guardar
    </button>
  </div>
</form>
